import { NgModule } from '@angular/core';
import { AssetUrlPipe } from './pipes/assets-url.pipe';

@NgModule({
  imports: [],
  declarations: [AssetUrlPipe],
  providers: [],
  exports: [AssetUrlPipe],
})
export class SharedModule {}
